import React from "react";

const TermsCondition = () => {
  return (
    <div className="terms-condition">
      <h2 className="text-center">Terms & Condition</h2>
    </div>
  );
};
export default TermsCondition;
